module.exports = __webpack_public_path__ + "static/media/108c5.f7e0233b.jpg";